import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TransactionModel } from "src/app/const/transaction-model.enum";
import { AppService } from "src/app/service/app.service";
import { DataService } from "src/app/service/data.service";
import { FilterComponent, IFilterData } from "../filter/filter.component";

@Component({
  selector: "app-payment-link",
  templateUrl: "./payment-link.component.html",
  styleUrls: ["./payment-link.component.scss"],
})
export class PaymentLinkComponent implements OnInit {
  @Input() isShowFilters: boolean;

  paymentLinks: any = [];
  activeIndex: any;
  limit: number = 20;
  skip: number = 1;
  loading = false;
  startDate: any = "";
  endDate: any = "";
  status: any = "";
  search: any = "";
  filterData: IFilterData = {};

  constructor(
    public dataService: DataService,
    public appService: AppService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.loading = true;
    this.getSessions(null);
  }

  async getSessions(event) {
    let params = {
      limit: this.limit,
      skip: this.skip,
      startDate: this.startDate,
      endDate: this.endDate,
      status: this.status,
      search: this.search,
    };

    this.dataService.viewAllPaymentLink(params).subscribe(
      (res: any) => {
        if (event) {
          event.target.complete();
          this.paymentLinks = this.paymentLinks.concat(res.data);
          if(res.data.length === 0){
            this.decrementSkip()
          }
        } else {
          this.paymentLinks = res.data;
        }
        this.loading = false;
      },
      (err) => {
        this.appService.toastMessage("Failed to fetch data");
        this.loading = false;
        if (event) {
          event.target.complete();
        }
      }
    );
  }

  searchPaymentLink(ev) {
    this.search = ev.target.value;
    this.getSessions(null);
  }

  filterActive() {
    if (this.startDate || this.endDate || this.status) {
      return true;
    }
    return false;
  }

  loadDataOnScroll(event) {
    this.skip = this.paymentLinks.length;
    this.getSessions(event);
  }

  async filter() {
    this.skip = 1;
    const modal = await this.modalCtrl.create({
      backdropDismiss: false,
      component: FilterComponent,
      componentProps: {
        transactionModel: TransactionModel.PAYMENTLINK,
        filterData: this.filterData,
        isStatusEnabled: true,
      },
    });
    modal.present();
    this.filterData = await (await modal.onWillDismiss()).data;
    this.endDate = this.filterData.endDate;
    this.startDate = this.filterData.fromDate;
    this.status = this.filterData.status;
    this.getSessions(null);
  }

  async viewPaymentLink(link) {
    const modal = await this.modalCtrl.create({
      component: ViewPaymentLink,
      componentProps: {
        link: link,
      },
    });
    modal.present();
  }

  decrementSkip(){
    if(this.skip > 1){
      this.skip -= 1;
    } 
  }
}

@Component({
  template: `
    <ion-content>
      <div style="text-align: center;padding: 10%;">
        <h2 style="color: #6bc048">
          OMR {{ (link?.totalAmount / 1000).toFixed(3) }}
        </h2>
        <div class="dotted-line"></div>

        <div class="addr">
          <p>{{"Created At" | translate}}: {{ link?.createdAt | date: "medium":"+0800" }}</p>
          <p>{{"Expire At" | translate}}: {{ link?.expireAt | date: "medium":"+0800" }}</p>
          <p *ngIf="!link?.billingAccount">{{"Referance ID" | translate}}: {{ link?.clientReferenceId }}</p>
          <p *ngIf="link?.billingAccount">{{"MSISDN( customer Number)" | translate}}: {{ link?.clientReferenceId }}</p>
          <p>{{"Invoice" | translate}}: {{ link?.invoice }}</p>
          <p>{{"billing Account" | translate}}: {{ link?.billingAccount }}</p>
          <p>{{"Sent By" | translate}}: {{ link?.metadata["Sent By"] }}</p>
          <p>{{"Contact Info" | translate}}: {{ link?.metadata?.customerPhone }}</p>
          <p>{{"Remarks" | translate}}: {{ link?.metadata?.remark }}</p>
        </div>
        <div class="dotted-line"></div>

        <div style="text-align:initial">
          <ion-row>
            <ion-col><h5>{{"Product Name" | translate}}</h5></ion-col>
            <ion-col><h5>{{"QTY" | translate}}</h5></ion-col>
            <ion-col><h5>{{"Price" | translate}}</h5></ion-col>
          </ion-row>
          <ion-row *ngFor="let item of link?.products">
            <ion-col
              ><p>{{ item?.name }}</p></ion-col
            >
            <ion-col
              ><p>{{ item?.quantity }}</p></ion-col
            >
            <ion-col
              ><p>{{ (item?.unitAmount / 1000).toFixed(3) }}</p></ion-col
            >
          </ion-row>
        </div>
      </div>
    </ion-content>
  `,
  styleUrls: ["./payment-link.component.scss"],
})
export class ViewPaymentLink {
  @Input() link;
}
